import http from '../utils/http';
import ValidateCoupon from '../view-model/payment/ValidateCoupon';
import Coupon from '../view-model/payment/Coupon';
import Subscribe from '../view-model/payment/Subscribe';
import Unsubscribe from '../view-model/payment/Unsubscribe';
import RequestUpgrade from '../view-model/payment/RequestUpgrade';
import UserInvoice from '../view-model/payment/UserInvoice';
import UserPaymentCheck from '../view-model/payment/UserPaymentCheck';
import authService from './auth';

const getHistory = (id: number) =>
    http.get<UserInvoice[]>(`/v2.1/users/${id}/invoices`);

const checkPayment = async (user: number, id: number) => {
    const response = await http.put<UserPaymentCheck>(`/v2.1/users/${user}/invoices/${id}/confirm-receipt`);

    if (response.result.confirmed) {
        try {
            await authService.updateUserInfo((await authService.getActiveUser())?.result);
        } catch (error) {
            window.location.reload();
        }
    }

    return response;
};

const getCoupons = (user: number) =>
    http.get<Coupon[]>(`/v2.1/users/${user}/coupons/reserved`);

const validateCoupon = ({ user, coupon, plan, interval, method, installments }: ValidateCoupon) =>
    http.get<Coupon>(`/v2.1/users/${user}/coupons/simulate?code=${coupon}&idPlan=${plan}&interval=${interval}&paymentMethod=${method}&installments=${installments}`);

const subscribe = ({ user, ...subscription }: Subscribe) =>
    http.post<null>(`/v2.1/users/${user}/subscriptions`, subscription, { credentials: 'include' });

const unsubscribe = ({ user, ...unsubscription }: Unsubscribe) =>
    http.post<null>(`/v2.1/users/${user}/subscriptions/unsubscription`, unsubscription);

const requestUpgrade = ({ user, ...request }: RequestUpgrade) =>
    http.post<null>(`/v2.1/users/${user}/subscriptions/change-request`, request);

const paymentsService = { getHistory, checkPayment, getCoupons, validateCoupon, subscribe, unsubscribe, requestUpgrade };

export default paymentsService;
